module.exports = __webpack_public_path__ + "img/empty.50e14792.svg";